import audit from './audit'; // 首页
import identity from './identity'; // 身份管理
import permissions from './permissions'; // 权限管理
// import auditMonitoring from './auditMonitoring'; // 审计监控
import comprehensiveQuery from './comprehensiveQuery'; // 综合查询
import ininCatorReport from './ininCatorReport'; // 报表治标
import systemSet from './systemSet'; // 系统设置
import tableQueryModal from './tableQueryModal'; // 宽表查询模板配置页面
import setTimeDowm from './setTimeDowm'; // 宽表查询模板配置页面
import labourUnionBusinessReport from './labourUnionBusinessReport'; // 宽表查询模板配置页面
// export default [...audit, ...identity, ...permissions, ...auditMonitoring];
export default [...audit, ...comprehensiveQuery, ...labourUnionBusinessReport, ...ininCatorReport, ...permissions, ...identity, ...systemSet, ...tableQueryModal, ...setTimeDowm];
